var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.iMostSing)?_c('v-btn',{attrs:{"outlined":"","small":"","color":"blue darken-3","disabled":_vm.itsSigned},on:{"click":_vm.firmarDocumento}},[_vm._v(" Firmar ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }